import { QuestionId, QuestionSetId } from '../types/GameplayTypes';

export const QUESTION_SHARE_PARAM = 'question';

/** Builds the admin URL used to share an existing question for editing. */
export function questionShareUrl(questionId: QuestionId): string {
	return toAbsoluteAdminUrl(`/admin/questions?${questionShareSearchParams(questionId).toString()}`);
}

/** Builds the admin URL used to share an existing question set for editing. */
export function questionSetShareUrl(questionSetId: QuestionSetId): string {
	return toAbsoluteAdminUrl(`/admin/question-sets/${questionSetId}`);
}

/** Creates the query parameters needed to open a specific question in the edit dialog. */
function questionShareSearchParams(questionId: QuestionId): URLSearchParams {
	return new URLSearchParams([[QUESTION_SHARE_PARAM, questionId]]);
}

/** Extracts a shared question ID from the current query parameters, if present. */
export function getSharedQuestionId(searchParams: URLSearchParams): QuestionId | undefined {
	const questionId = searchParams.get(QUESTION_SHARE_PARAM);
	return questionId ? questionId as QuestionId : undefined;
}

/** Copies a share URL to the clipboard. */
export async function copyShareUrlToClipboard(url: string) {
	if (navigator.clipboard?.writeText) {
		await navigator.clipboard.writeText(url);
	} else {
		throw new Error('Clipboard is not available');
	}
}

function toAbsoluteAdminUrl(path: string): string {
	return new URL(path, window.location.origin).toString();
}
